import IndicatorFieldsFragment from "components/financials/modern/graphql/fragments/IndicatorFieldsFragment";
import gql from "graphql-tag";

export default gql`
  query Indicators($objectIds: [IndicatorID!], $filters: IndicatorsFilters) {
    indicators(objectIds: $objectIds, filters: $filters) {
      ...IndicatorFields
    }
  }

  ${IndicatorFieldsFragment}
`;
